import { Planning, PlanningRate, Shift } from "../../../redux/apis/types";
import { DiffHours } from "../../../redux/apis/utils";

export const RoundFloat = (amount: number) => parseFloat(amount.toFixed(2));
export const getInvoiceRateData = (shifts: Shift[]) => {
  return shifts.map((item) => {
    const surcharge = getSubcInvoiceSurcharge(item);
    const branchSurcharge = getBranchInvoiceSurcharge(item);
    // const { surcharge, currency } = calculateSurcharge(item, holidays);

    const purchaseCostPerHour = getInvoiceShiftSubcRate(item);
    const salesCostPerHour = getInvoiceShiftClientRate(item.planning);
    const totalHours = DiffHours(item.start, item.end);

    const numberOfActualAgents = item.agent_shifts.length || 1;
    const numberOfPlanningAgents = numberOfActualAgents;
    // const numberOfPlanningAgents = item.planning.number_of_agents;

    const margeRatePerHour = RoundFloat(
      salesCostPerHour.amount - purchaseCostPerHour.amount
    );

    const totalPurchaseCost = RoundFloat(
      purchaseCostPerHour.amount * totalHours * numberOfActualAgents
    );

    const totalSalesCost = RoundFloat(
      salesCostPerHour.amount * totalHours * numberOfPlanningAgents
    );

    const totalPurchaseCostWithSurcharge = RoundFloat(
      totalPurchaseCost + surcharge
    );

    const totalSalesCostWithSurcharge = RoundFloat(
      totalSalesCost + branchSurcharge
    );

    const totalMargeRate = RoundFloat(
      totalSalesCostWithSurcharge - totalPurchaseCostWithSurcharge
    );
    let margePercentage = 0;

    if (totalSalesCostWithSurcharge > 0) {
      margePercentage = RoundFloat(
        (totalMargeRate / totalSalesCostWithSurcharge) * 100
      );
    }

    return {
      ...item,
      key: item.id,
      sales_cost_per_hour: salesCostPerHour.amount,
      purchase_cost_per_hour: purchaseCostPerHour.amount,
      total_purchase_cost_with_surcharge: totalPurchaseCostWithSurcharge,
      marge_rate: margeRatePerHour,
      total_sales_cost: totalSalesCost,
      total_sales_cost_with_surcharge: totalSalesCostWithSurcharge, // surcharge missing
      total_purchase_cost: totalPurchaseCost,
      surcharge,
      purchaseCurrency: purchaseCostPerHour.currency,
      salesCurrency: salesCostPerHour.currency,
      total_marge: totalMargeRate,
      total_marge_percentage: margePercentage,
      total_hours: totalHours,
      number_of_agents: numberOfActualAgents,
      branch_surcharge: branchSurcharge,
    };
  });
};
export const getInvoiceShiftClientRate = (planning: Planning, hours = 1) => {
  if (!planning.invoice_id && planning?.branch_rate?.rate) {
    return {
      amount: (planning?.branch_rate?.rate || 0) / 100,
      currency: planning?.branch_rate?.currency,
    };
  }
  const work = planning.invoice?.data?.work || [];

  for (let i = 0; i < work.length; i++) {
    const planningRate = work[i].planningRates.find(
      (item) => item.planningId === planning.id
    );
    if (planningRate) {
      return {
        amount: planningRate.price || 0,
        currency: planningRate.currency,
      };
    }
  }

  return { amount: 0, currency: "" };
};

export const getSubcInvoiceSurcharge = (shift: Shift) => {
  if (!shift.subcontractor_invoice_id) return 0;

  const invoiceShift: any = shift.subcontractor_invoice?.data?.work?.find(
    (item: any) => item.id === shift.id
  );

  return invoiceShift?.surcharge || 0;
};
export const getBranchInvoiceSurcharge = (shift: Shift) => {
  if (!shift?.planning?.invoice_id) return 0;

  const groups: any = shift.planning?.invoice?.data?.work?.filter(
    (item: any) => !!item.surchargeKey
  );

  let surcharge = 0;
  for (let i = 0; i < groups.length; i++) {
    const planningRates = groups[i]?.planningRates as PlanningRate[];
    if (planningRates) {
      for (let j = 0; j < planningRates.length; j++) {
        if (
          planningRates[j] &&
          planningRates[j].planningId === shift.planning_id
        ) {
          surcharge += planningRates[j].total || 0;
        }
      }
    }
  }

  return surcharge;
};
export const getInvoiceShiftSubcRate = (shift: Shift, hours = 1) => {
  const planning = shift.planning;
  if (
    !shift.subcontractor_invoice_id &&
    planning?.branch_rate?.subcontractor_rates &&
    planning?.branch_rate?.subcontractor_rates.length > 0 &&
    planning?.branch_rate_id
  ) {
    const subcRate = planning?.branch_rate?.subcontractor_rates.find(
      (item) =>
        item.branch_rate_id + "" === planning.branch_rate_id + "" &&
        shift.subcontractor_id === item.subcontractor_id
    );
    if (subcRate) {
      return {
        amount: subcRate?.rate / 100,
        currency: subcRate?.currency,
      };
    }
  }

  if (shift.subcontractor_invoice_id) {
    const invoiceShift: any = shift.subcontractor_invoice?.data?.work?.find(
      (item: any) => item.id === shift.id
    );

    return {
      amount: parseFloat(invoiceShift?.purchase_cost_per_hour),
      currency: shift.subcontractor_invoice?.currency,
    };
  }

  return { amount: 0, currency: "" };
};
